import { number, object } from "yup";

import { IWorkflowSave } from "@/interfaces/workflow.interface";
import { WorkflowSaveDialogMessages } from "@/messages/workflow/workflow-save-dialog.messages";

import { IWorkFlowFormData } from "./types";

export const buildWorkflowActivationInitialData = (): IWorkFlowFormData => {
  return {
    workflowTypeId: -1,
    name: "",
    description: "",
    workflowId: -1,
  };
};

export const buildWorkflowActivationFormSchema = (messages: WorkflowSaveDialogMessages) =>
  object().shape({
    workflowId: number()
      .positive(messages.errorRequiredWorkflowId)
      .required(messages.errorRequiredWorkflowId),
    workflowTypeId: number()
      .positive(messages.errorRequiredTrigger)
      .required(messages.errorRequiredTrigger),
  });

export const normalizeFormData = (formData: IWorkFlowFormData): IWorkflowSave => {
  return {
    workflowTemplateId: formData.workflowId,
  };
};
